import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Elements from 'element-plus'
import 'element-plus/dist/index.css' // Import element-plus CSS
import { createPinia } from 'pinia'
import './assets/styles/global.scss' // 引入全局样式文件
const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(Elements)

app.mount('#app')
